
import heroGif from "../../assets/Untitled design (5).mp4";
import { Link } from 'react-router-dom';


export function HeroSection() {
  return (
    <section className="w-full py-6 sm:py-8">
      
      {/* Full Width Wrapper */}
      <div className="relative overflow-hidden rounded-none sm:rounded-none">

        {/* Background Video */}
<video
  autoPlay
  loop
  muted
  playsInline
   preload="metadata"
  className="absolute inset-0 w-full h-full object-cover  scale-110"
>
  <source src={heroGif} type="video/mp4" />
</video>


<div className="absolute inset-0 bg-black/60"></div>


        {/* Content Container (Centered but not constrained visually) */}
        <div className="relative grid md:grid-cols-2 gap-6 items-center 
                      py-20 sm:py-24 lg:py-32

                        px-4 sm:px-6 lg:px-12 
                        max-w-7xl mx-auto
                         font-['Poppins']">
          
          {/* Left Content */}
          <div className="space-y-4 text-white">
            <h1 className="text-2xl sm:text-3xl font-semibold lg:text-4xl leading-tight">
              Connect with Verified Experts
              <span className="block mt-1">Anytime, Anywhere</span>
            </h1>

            <p className="text-sm sm:text-base text-white/90">
              Get personalized consultations across multiple categories including astrology, legal, medical, and more.
              <span className="block mt-1">
                Chat • Call • Video available 24/7
              </span>
            </p>

          <div className="flex flex-wrap gap-3 pt-2">
              <Link to="/experts" className="px-5 sm:px-6 py-2.5 sm:py-3 bg-white text-blue-900 rounded-xl hover:bg-blue-50 transition-all flex items-center gap-2 shadow-lg text-sm sm:text-base font-medium">
                {/* <MessageCircle className="w-4 h-4" /> */}
                <span>Consult Now</span>
              </Link>

              <Link to="/categories" className="px-5 sm:px-6 py-2.5 sm:py-3 bg-transparent text-white border-2 border-white rounded-xl hover:bg-white/10 transition-all flex items-center gap-2 text-sm sm:text-base font-medium">
                {/* <Phone className="w-4 h-4" /> */}
                <span>Browse Categories</span>
              </Link>
            </div>
          </div>

          {/* Right side empty */}
          <div className="hidden md:block"></div>
        </div>
      </div>
    </section>
  );
}
